export enum TourType {
  WALKTHROUGH,
  NEWS
}

export enum TourKeys {
  HOME = 'HOME',
  MOMO_SCHEDULE = 'MOMO'
}
